import React from 'react';

import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import Tooltip from 'components/Tooltip';

import { getEntityFromProfile } from 'utils/view';

import type { BrandProfile } from 'types';

type Props = {
  brandProfileId: number,
  brandProfile: BrandProfile | undefined | null
};

class CampaignsTableBrandCell extends React.PureComponent<Props> {
  render() {
    const { brandProfile, brandProfileId } = this.props;
    const brandProfileEntity = getEntityFromProfile(brandProfile);

    return (
      <div className="campaigns-table-brand-cell">
        <Tooltip
          message={brandProfile?.name ?? ''}
          width="short"
          display="flex"
        >
          <EntityAvatar
            entity={brandProfileEntity}
            bordered
            size="customSize"
            customSize={{
              width: 48,
              height: 48
            }}
            hideTitle
            className="campaigns-table-brand-cell__logo"
            link={`/brand/profiles/${brandProfileId}`}
          />
        </Tooltip>
      </div>
    );
  }
}

export default CampaignsTableBrandCell;
